import routerOptions0 from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}